import { DailyRVUStat } from "../../../types/DailyRVUStat";
import { Badge, Td, Text } from "@chakra-ui/react";
import DailyRVURowGraph from "./DailyRVURowGraph";

const DailyRVURow: React.FC<DailyRVUStat> = ({ name, disabled, ...rvuProps }) => {
  return (
    <>
      <Td width="25%">
        <Text textStyle={"smMdSemi"} textAlign={"end"}>
          {name}
          {disabled && (
            <Badge mx={2} colorScheme="error">
              Deleted
            </Badge>
          )}
        </Text>
      </Td>
      <Td colSpan={3}>
        <DailyRVURowGraph {...rvuProps} />
      </Td>
      <Td></Td>
      <Td></Td>
    </>
  );
};

export default DailyRVURow;
